import { useEffect } from 'react';
import { BrandLogo } from './BrandLogo';
import { LegalFooter } from './LegalFooter';
import { trackEvent } from '../lib/analytics';

export function NotFoundPage() {
  useEffect(() => {
    document.title = 'Pagina niet gevonden | ProPickleball.nl';
    trackEvent({ event: 'no_result_view', location: 'not_found', label: window.location.pathname, routeFamily: '404' });
  }, []);

  return (
    <>
      <main className="notFoundPage">
        <BrandLogo compact />
        <section>
          <p className="eyebrow">404</p>
          <h1>Pagina niet gevonden.</h1>
          <p>Deze route bestaat niet of is nog niet gepubliceerd. Probeer een van de populaire pagina's hieronder.</p>
          <div className="ctaRow inlineCtaRow">
            <a className="primaryCta" href="/keuzehulp/">Doe de keuzehulp</a>
            <a className="secondaryDarkCta" href="/">Terug naar home</a>
          </div>
          <nav className="notFoundLinks" aria-label="Populaire pagina's">
            <a href="/producten/">Shop alle producten</a>
            <a href="/collecties/paddles/">Paddles</a>
            <a href="/collecties/startersets/">Startersets</a>
            <a href="/collecties/ballen/">Ballen</a>
            <a href="/leren/">Leren: kennisbank</a>
            <a href="/pickleball-clubpakket/">Clubs &amp; scholen</a>
          </nav>
        </section>
      </main>
      <LegalFooter />
    </>
  );
}
